import React from 'react';
import { Link } from 'react-router-dom';
import { Heart, ExternalLink } from 'lucide-react';
import { comparisons } from '../data/comparisons';

const Footer: React.FC = () => {
  return (
    <footer className="bg-charcoal-panel border-t border-charcoal-border text-gray-900 py-8 mt-auto">
      <div className="container mx-auto px-4">
        {/* Comparisons — internal links for crawlability + topical authority */}
        <nav className="mb-6 text-center" aria-label="Comparisons">
          <p className="text-faint font-mono text-xs uppercase tracking-widest mb-2">Compare</p>
          <div className="flex flex-wrap justify-center gap-x-4 gap-y-2 text-sm">
            <Link to="/best-ai-code-analysis-tools" className="text-muted hover:text-lime transition-colors">
              Best AI code analysis tools
            </Link>
            <Link to="/ai-coding-tools" className="text-muted hover:text-lime transition-colors">
              AI coding tools
            </Link>
            <Link to="/compare" className="text-muted hover:text-lime transition-colors">
              All comparisons
            </Link>
            {comparisons.map((c) => (
              <Link
                key={c.slug}
                to={`/compare/githubmate-vs-${c.slug}`}
                className="text-muted hover:text-lime transition-colors"
              >
                vs {c.competitor}
              </Link>
            ))}
          </div>
        </nav>

        <div className="text-center">
          <p className="text-muted text-sm flex items-center justify-center space-x-1">
            <span>Made with</span>
            <Heart className="h-4 w-4 text-red-500 fill-current" />
            <span>by</span>
            <a
              href="https://au.linkedin.com/in/manojalwis"
              target="_blank"
              rel="noopener noreferrer"
              className="text-lime hover:underline transition-colors font-medium flex items-center space-x-1"
            >
              <span>Manoj Alwis</span>
              <ExternalLink className="h-3 w-3" />
            </a>
            <span className="text-gray-500">· Founder of GitHubMate</span>
          </p>
        </div>
      </div>
    </footer>
  );
};

export default Footer; 